<template>
  <div class="main-app">
    <Swiper :swiperImgs="swiperImgs" />
    <div class="container">
      <div class="content">
        <el-row>
          <el-col :span="14" :xs="24">
            <div class="title">{{ $t("introduce") }}</div>
            <div
              class="info-box"
              v-html="
                aboutIndexData !== undefined ? aboutIndexData.content : ''
              "
            ></div>
          </el-col>
          <el-col :span="10" :xs="24">
            <div class="img-box">
              <div class="xc-img">
                <img :src="aboutContact && aboutContact.sloganimage" alt="" />
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" :xs="24">
            <div class="title">{{ $t("contactUs") }}</div>
            <div class="img-box">
              <div class="maps-img">
                <img :src="aboutContact && aboutContact.footerimage" alt="" />
              </div>
            </div>
          </el-col>
          <el-col :span="8" :xs="24">
            <div class="maps-box">
              <div class="maps-item">
                <div class="text text-tel">
                  {{ aboutIndexData && aboutIndexData.tel }}
                </div>
                <div class="icon">
                  <div class="icon-img">
                    <img src="~@a/img/about-tel.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="maps-item">
                <div class="text">
                  {{ aboutIndexData && aboutIndexData.address }}
                </div>
                <div class="icon">
                  <div class="icon-img">
                    <img src="~@a/img/about-maps.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="maps-item">
                <div class="text">
                  {{ aboutIndexData && aboutIndexData.email }}
                </div>
                <div class="icon">
                  <div class="icon-img">
                    <img src="~@a/img/about-mail.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import LStore from "store";
import { mapState } from "vuex";
import API from "@/api";
import Swiper from "@c/Swiper";

export default {
  data() {
    return {
      src: require("@a/img/banner-about.png"),
      aboutIndexData: undefined,
      swiperImgs: []
    };
  },
  components: {
    Swiper
  },
  computed: {
    ...mapState(["aboutContact"])
  },
  created() {
    this.topingAll();
    this.productCat();
    this.aboutIndex();
  },
  methods: {
    ...mapMutations(["PRODUCT_DATA"]),
    productCat(params) {
      API.productCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.PRODUCT_DATA(res.data);
          LStore.set("productData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    topingAll(params) {
      API.topingAll(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(
            this,
            "swiperImgs",
            res.data.filter(v => Number(v.typelist) === 5)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    aboutIndex(params) {
      API.aboutIndex(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "aboutIndexData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  margin: 60px 0 20px;
  font-size: 24px;
  color: var(--color-light-black);
}

.info-box {
  width: 90%;
  line-height: 30px;
  font-size: 16px;
  color: var(--color-light-black);
}

.xc-img {
  width: 80%;
  margin-top: 40px;
}

.content {
  margin-bottom: 60px;
}

.maps-box {
  padding: 160px 50px 0;
  font-size: 16px;
  color: var(--color-light-grey);

  .maps-item {
    display: flex;
    height: 80px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    line-height: 25px;

    &:not(:last-child) {
      border-bottom: 1px solid var(--color-line-grey);
    }

    .text {
      flex-basis: 90%;

      &.text-tel {
        font-size: 26px;
      }
    }

    .icon-img {
      width: 20px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .info-box,
  .xc-img {
    width: 100%;
  }

  .maps-box {
    padding: 40px 20px 0;
  }
}
</style>
